module.exports = __webpack_public_path__ + "static/media/elcano_2.e4a1b4ce.png";